import { Injectable } from '@angular/core';
import { GgInStockReminderAdapter } from './in-stock-reminder.adapter';
import { Observable } from 'rxjs';

@Injectable()
export class GgInStockReminderConnector {
  constructor(protected adapter: GgInStockReminderAdapter) {}

  remindUser(productCode: string, email: string, subscriptions: string[]) {
    return this.adapter.remindUser(productCode, email, subscriptions);
  }
}
